<script setup>
import {__, _mareike_nonce, notify} from "../../../assets/javascripts/library";
import TabbedPage from "../../../assets/components/TabbedPage.vue";
import Invoices from "../invoices/ListMyInvoices.vue";

const props = defineProps({
  data: {
    type: [Array, Object],
    default: () => []
  },
  show_category: {
    type: String,
    default: 'new'
  },

})

console.log('Test');

// Prüfen, ob ein ?id= Parameter in der URL übergeben wurde
const urlParams = new URLSearchParams(window.location.search)
const initialCostUnitId = props.cost_unit_id
const initialInvoiceId = props.invoice_id

const tabs = [
  {
    title: __('New invoices', 'mareike'),
    component: Invoices,
    endpoint: "/wp-json/mareike/my-invoices/new-invoices?mareike_nonce=" + _mareike_nonce(),
    deep_jump_id: props.show_category,
    deep_jump_id_sub: initialInvoiceId,

  },
  {
    title: __('Approved invoices', 'mareike'),
    component: Invoices,
    endpoint: "/wp-json/mareike/my-invoices/approved-invoices?mareike_nonce=" + _mareike_nonce(),
    deep_jump_id: initialCostUnitId,
    deep_jump_id_sub: initialInvoiceId,
  },
  {
    title: __('Denied invoices', 'mareike'),
    component: Invoices,
    endpoint: "/wp-json/mareike/my-invoices/denied-invoices?mareike_nonce=" + _mareike_nonce(),
    deep_jump_id: initialCostUnitId,
    deep_jump_id_sub: initialInvoiceId,
  },
]
</script>

<template>
  <TabbedPage :tabs="tabs" />
</template>
